import React, { PureComponent } from 'react'
import { DEVICES, SOURCE_STRINGS } from '../../../constants'
import NewsFeedInfo from './StyledNewsFeedInfo'
import NewsFeedItem from './NewsFeedItem'
import { sendArticleClick } from '../../utils/ga4Events'

class NewsFeedItemArticle extends PureComponent {
  constructor (props) {
    super(props)
    this.handleAnchorClick = this.handleAnchorClick.bind(this)
  }

  handleAnchorClick (event, location) {
    event.preventDefault()

    const {
      box: {
        guid: id,
        title: name,
        link,
        originalLink = link
      },
      position,
      itemVariant
    } = this.props

    sendArticleClick({
      id,
      position: position + 1,
      boxName: 'newsFeed',
      url: originalLink,
      title: name,
      variant: itemVariant
    })

    const { layout } = this.props
    if (layout === DEVICES.DESKTOP) {
      window.open(location)
      return false
    } else {
      document.location.href = location
    }
  }

  render () {
    const {
      box,
      box: {
        source,
        category
      },
      layout
    } = this.props

    return (
      <NewsFeedItem handleAnchorClick={this.handleAnchorClick} {...box} layout={layout}>
        <NewsFeedInfo source={source}>
          {SOURCE_STRINGS[source]}
          {
            category &&
            ` | ${category}`
          }
        </NewsFeedInfo>
      </NewsFeedItem>
    )
  }
}

export default NewsFeedItemArticle
